import { render, staticRenderFns } from "./rmHowz.vue?vue&type=template&id=4cd1fb34"
import script from "./rmHowz.vue?vue&type=script&lang=js"
export * from "./rmHowz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports